export const lockPortraitOrientation = async (): Promise<void> => {
  if (typeof window === 'undefined' || typeof screen === 'undefined') return;
  try {
    const orientation = (screen as any).orientation;
    if (orientation && typeof orientation.unlock === 'function') {
      orientation.unlock();
    }
  } catch {}
};

export const unlockOrientationForVideo = async (): Promise<void> => {
  if (typeof window === 'undefined' || typeof screen === 'undefined') return;
  try {
    const orientation = (screen as any).orientation;
    if (orientation) {
      if (typeof orientation.unlock === 'function') {
        orientation.unlock();
      }
      if (typeof orientation.lock === 'function') {
        orientation.lock('any').catch(() => {});
      }
    }
  } catch {}
};
